import moment from "moment-timezone";

const dateFormat = [
    {
        "id": "1",
        "date": "l",
        "name": "m/d/Y (" + new Date().toLocaleDateString("en-US") + ")"
    },
    {
        "id": "2",
        "date": "D/M/YYYY",
        "name": "d/m/Y (" + (new Date().getDate()) + "/" + (new Date().getMonth() + 1) + "/" + (new Date().getFullYear()) + ")"
    },
    {
        "id": "3",
        "date": "YYYY/M/D",
        "name": "Y/m/d (" + (new Date().getFullYear()) + "/" + (new Date().getMonth() + 1) + "/" + (new Date().getDate()) + ")"
    },
    {
        "id": "4",
        "date": "YYYY/D/M",
        "name": "Y/d/m (" + (new Date().getFullYear()) + "/" + (new Date().getDate()) + "/" + (new Date().getMonth() + 1) + ")"
    },
    {
        "id": "5",
        "date": "M-D-YYYY",
        "name": "m-d-Y (" + (new Date().getMonth() + 1) + "-" + (new Date().getDate()) + "-" + (new Date().getFullYear()) + ")"
    },
    {
        "id": "6",
        "date": "D-M-YYYY",
        "name": "d-m-Y (" + (new Date().getDate()) + "-" + (new Date().getMonth() + 1) + "-" + (new Date().getFullYear()) + ")"
    },
    {
        "id": "7",
        "date": "M.D.YYYY",
        "name": "m.d.Y (" + (new Date().getMonth() + 1) + "." + (new Date().getDate()) + "." + (new Date().getFullYear()) + ")"
    },
    {
        "id": "8",
        "date": "D.M.YYYY",
        "name": "d.m.Y (" + (new Date().getDate()) + "." + (new Date().getMonth() + 1) + "." + (new Date().getFullYear()) + ")"
    },
    {
        "id": "9",
        "date": "ll",
        "name": "MMM DD, YY (" + moment(new Date()).format("ll") + ")"
    },
];

export default dateFormat;